import React from 'react';
import { useDispatch } from 'react-redux';

import SectionHeader from './SectionHeader';
import Textarea from '../../components/Textarea';

const Viability = ({
  data: { description, showStatus },
  locales: { portfolio },
  disabled = false,
}) => {
  const {
    portfolio: { updateSectionField, updateSectionFieldReducer },
  } = useDispatch();

  const setShowStatus = (status) => {
    updateSectionFieldReducer({
      sectionName: 'viability',
      field: 'showStatus',
      value: status,
    });
  };

  return (
    <div className="viability">
      <SectionHeader
        locales={portfolio}
        showStatus={showStatus}
        sectionName={portfolio.viability.sectionTitle}
        setShowStatus={setShowStatus}
        mainColor="purple"
      />
      {showStatus && (
        <Textarea
          name="textarea"
          delay={700}
          value={description}
          onChange={(e) =>
            updateSectionField({
              sectionName: 'viability',
              field: 'description',
              name: 'viabilityText',
              value: e.target.value,
            })
          }
          className="bmc-form-textarea textarea"
          placeholder={portfolio.page.descriptionPlaceholder}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default Viability;
